import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { YellowButton } from "../../components/UI/Button/button";
import {
  PRIVACYPOLICY,
  POLICYTABLEOFCONTENT,
  PRIVACY_POLICY_META,
} from "../../constants";
import classes from "./TermsAndPolicy.module.css";
import DOMPurify from "dompurify";
const PrivacyPolicy = () => {
  const ref = useRef([]);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const renderBlocks = (blocks, keyPrefix, depth = 0) => {
    if (!blocks || blocks.length === 0) return null;

    return blocks.map((block, index) => {
      const key = `${keyPrefix}-${index}`;

      if (block.type === "paragraph") {
        return (
          <p
            key={key}
            className="mt-2"
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(block.text) }}
          />
        );
      }

      if (block.type === "list") {
        return (
          <ul key={key}>
            {block.items.map((item, itemIndex) => (
              <li
                key={`${key}-item-${itemIndex}`}
                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item) }}
              />
            ))}
          </ul>
        );
      }

      if (block.type === "subsection") {
        return (
          <div key={key} style={{ marginTop: depth === 0 ? "20px" : "10px" }}>
            {block.heading && (
              <h4 className="mb-sm !text-base !font-bold">{block.heading}</h4>
            )}
            {renderBlocks(block.blocks, key, depth + 1)}
          </div>
        );
      }

      return null;
    });
  };

  return (
    <div className={`mt-md ${classes.terms}`}>
      <h3 className="mb-28">Last Revised: {PRIVACY_POLICY_META.lastUpdated}</h3>

      {/* Table of Contents */}
      <h3 className="mt-md mb-md">TABLE OF CONTENTS</h3>
      {POLICYTABLEOFCONTENT.map((content, index) => (
        <button
          key={`content-${index}`}
          className={`${classes.content}`}
          onClick={() =>
            ref.current[index].scrollIntoView({ behavior: "smooth" })
          }
        >
          {+index + 1}. {content}
        </button>
      ))}

      {/* Privacy Policy Sections */}
      <ol>
        {PRIVACYPOLICY.map((section, index) => (
          <li
            key={`mapped-policy-${index}`}
            id={section.id}
            ref={(el) => (ref.current[index] = el)}
          >
            <h3 className="mt-bg mb-9">
              {+index + 1}. {section.title}
            </h3>

            {renderBlocks(section.blocks, `section-${index}`)}
          </li>
        ))}
      </ol>
    </div>
  );
};

export default PrivacyPolicy;
